import ArtifactGroupType from "../base/ArtifactGroupType";


const PharaosGold = {
  id: '106',
  name: 'Pharaos Gold',
  groupIcon: 'TreasuresOfTheNile',
  type: ArtifactGroupType.TREASURES_OF_THE_NILE,
  icon: 'PharaosGold',
  power: 10
};

export default PharaosGold;
